import React, { useMemo } from "react";
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { loadApplyFormData } from "./applyFormStorage";

export default function ApplyFinalConfirmationPage() {
  const navigate = useNavigate();

  const amountRequested = useMemo(() => {
    const stored = loadApplyFormData();
    const loanAmount = stored.preliminary && typeof stored.preliminary === "object" ? stored.preliminary.loanAmount || "" : "";
    const normalizedAmount = Number(loanAmount);

    if (!Number.isFinite(normalizedAmount) || normalizedAmount <= 0) {
      return "";
    }

    return `$${normalizedAmount.toLocaleString()}`;
  }, []);

  return (
    <Box width="100%" bg="gray.50" minH="100vh" pt={{ base: 28, md: 32 }} pb={{ base: 12, md: 16 }} px={{ base: 4, md: 8 }}>
      <VStack maxW="760px" mx="auto" spacing={8} align="stretch">
        <Box border="1px solid" borderColor="gray.200" borderRadius="2xl" bg="white" boxShadow="sm" px={{ base: 5, md: 8 }} py={{ base: 7, md: 9 }}>
          <VStack spacing={4} align="stretch" textAlign="center">
            <Heading size="lg">Application received</Heading>
            <Text color="gray.700">Thanks for completing your application. We&apos;ll review it and contact you shortly.</Text>
            {amountRequested && (
              <Text color="gray.600" fontSize="sm">
                Amount requested: <strong>{amountRequested}</strong>
              </Text>
            )}
            <Button mt={2} bg="black" color="white" borderRadius="full" h="50px" px={8} _hover={{ bg: "gray.900" }} onClick={() => navigate("/profile")}>
              Return to profile
            </Button>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
}
